import { AllocationKey, CommitmentCalculation } from "api/ux/src";
import { Region } from "common/regions";
import { UserPreferencesDateFormatEnum } from "components/modal/settings/date-formats";
import { UserPreferencesNegativeNumberFormatEnum } from "components/modal/settings/negative-number-formats";
import { UserPreferencesUnitOfAreaEnum } from "components/modal/settings/unitOfArea";
const allocationKeyFromBackend = {
    COMMITMENT: AllocationKey.Commitment,
    GROSS_NAV: AllocationKey.GrossNav,
    GROSS_NAV_HYBRID: AllocationKey.GrossNavHybrid,
    HYBRID: AllocationKey.Hybrid,
    NAV: AllocationKey.Nav
};
const allocationKeyToBackend = {
    [AllocationKey.Commitment]: "COMMITMENT",
    [AllocationKey.GrossNav]: "GROSS_NAV",
    [AllocationKey.GrossNavHybrid]: "GROSS_NAV_HYBRID",
    [AllocationKey.Hybrid]: "HYBRID",
    [AllocationKey.Nav]: "NAV"
};
const commitmentCalculationFromBackend = {
    HISTORICAL_COMMITMENT: CommitmentCalculation.HistoricalCommitment,
    RECOMPUTED_COMMITMENT: CommitmentCalculation.RecomputedCommitment
};
const commitmentCalculationToBackend = {
    [CommitmentCalculation.HistoricalCommitment]: "HISTORICAL_COMMITMENT",
    [CommitmentCalculation.RecomputedCommitment]: "RECOMPUTED_COMMITMENT"
};
const regionFromBackend = {
    EN_GB: Region.enGB,
    EN_US: Region.enUS,
    FR_FR: Region.frFR
};
const regionToBackend = {
    [Region.enGB]: "EN_GB",
    [Region.enUS]: "EN_US",
    [Region.frFR]: "FR_FR"
};
const dateFormatFromBackend = {
    LOCALIZED: UserPreferencesDateFormatEnum.Localized,
    SHORT_LOCALIZED: UserPreferencesDateFormatEnum.ShortLocalized
};
const dateFormatToBackend = {
    [UserPreferencesDateFormatEnum.Localized]: "LOCALIZED",
    [UserPreferencesDateFormatEnum.ShortLocalized]: "SHORT_LOCALIZED"
};
const negativeNumberFormatFromBackend = {
    BRACKETED: UserPreferencesNegativeNumberFormatEnum.Bracketed,
    MINUS_PREFIXED: UserPreferencesNegativeNumberFormatEnum.MinusPrefixed
};
const negativeNumberFormatToBackend = {
    [UserPreferencesNegativeNumberFormatEnum.Bracketed]: "BRACKETED",
    [UserPreferencesNegativeNumberFormatEnum.MinusPrefixed]: "MINUS_PREFIXED"
};
const unitOfAreaFromBackend = {
    ACRE: UserPreferencesUnitOfAreaEnum.Acre,
    HECTARE: UserPreferencesUnitOfAreaEnum.Hectare,
    SQUARE_FOOT: UserPreferencesUnitOfAreaEnum.SquareFoot,
    SQUARE_METER: UserPreferencesUnitOfAreaEnum.SquareMeter
};
const unitOfAreaToBackend = {
    [UserPreferencesUnitOfAreaEnum.Acre]: "ACRE",
    [UserPreferencesUnitOfAreaEnum.Hectare]: "HECTARE",
    [UserPreferencesUnitOfAreaEnum.SquareFoot]: "SQUARE_FOOT",
    [UserPreferencesUnitOfAreaEnum.SquareMeter]: "SQUARE_METER"
};
const stringFromUnknown = (value) => {
    if (typeof value === "string") {
        return value;
    }
    return undefined;
};
export const mapBackendUserPreferencesToUserPreferences = (preferences) => {
    const allocationKey = stringFromUnknown(preferences?.allocationKey);
    const commitmentCalculation = stringFromUnknown(preferences?.commitmentCalculation);
    const dateFormat = stringFromUnknown(preferences?.dateFormat);
    const negativeNumberFormat = stringFromUnknown(preferences?.negativeNumberFormat);
    const region = stringFromUnknown(preferences?.region);
    const unitOfArea = stringFromUnknown(preferences?.unitOfArea);
    return {
        allocationKey: allocationKey ? allocationKeyFromBackend[allocationKey] : undefined,
        commitmentCalculation: commitmentCalculation ? commitmentCalculationFromBackend[commitmentCalculation] : undefined,
        dateFormat: dateFormat ? dateFormatFromBackend[dateFormat] : undefined,
        enableJSONEditing: preferences?.enableJsonEditing,
        negativeNumberFormat: negativeNumberFormat ? negativeNumberFormatFromBackend[negativeNumberFormat] : undefined,
        region: region ? regionFromBackend[region] : undefined,
        unitOfArea: unitOfArea ? unitOfAreaFromBackend[unitOfArea] : undefined
    };
};
export const mapUserPreferencesToBackendUserPreferences = (preferences) => ({
    allocationKey: preferences.allocationKey ? allocationKeyToBackend[preferences.allocationKey] : undefined,
    commitmentCalculation: preferences.commitmentCalculation ? commitmentCalculationToBackend[preferences.commitmentCalculation] : undefined,
    dateFormat: preferences.dateFormat ? dateFormatToBackend[preferences.dateFormat] : undefined,
    enableJsonEditing: preferences.enableJSONEditing,
    negativeNumberFormat: preferences.negativeNumberFormat ? negativeNumberFormatToBackend[preferences.negativeNumberFormat] : undefined,
    region: preferences.region ? regionToBackend[preferences.region] : undefined,
    unitOfArea: preferences.unitOfArea ? unitOfAreaToBackend[preferences.unitOfArea] : undefined
});
